import { FormActions } from "seneca-common/utils/form/state/actionTypes";
import {
  ActionType,
  ActionTypeRegisterField,
  ActionTypeResetErrors,
  ActionTypeSetFieldValue,
  ActionTypeSetFormErrors,
  ActionTypeSetFormFieldsErrors,
  ActionTypeSetFormLoading
} from "seneca-common/utils/form/state/types";
import {
  Fields,
  FormState,
  InitFormState
} from "seneca-common/utils/form/types";

export const initState: InitFormState = (props: Fields = {}) => ({
  data: { ...props.initialValues },
  validators: {},
  errors: {},
  loaders: {}
});

export default function FormReducer(state: FormState, action: ActionType) {
  switch (action.type) {
    case FormActions.setFieldValue: {
      const { form, fieldName, value } =
        action.payload as ActionTypeSetFieldValue;

      const updatedState = { ...state };
      updatedState.data[form][fieldName] = value;
      updatedState.errors[form][fieldName] = [];
      return updatedState;
    }

    case FormActions.setFormLoading: {
      const { form, isLoading } = action.payload as ActionTypeSetFormLoading;

      const updatedState = { ...state };
      updatedState.loaders[form] = isLoading;
      return updatedState;
    }

    case FormActions.setFormErrors: {
      const { form, errors } = action.payload as ActionTypeSetFormErrors;

      const updatedState = { ...state };
      updatedState.errors[form][form] = errors;
      return updatedState;
    }

    case FormActions.resetFormState: {
      return initState();
    }

    case FormActions.registerField: {
      const { form, fieldName, defaultValue, validators } =
        action.payload as ActionTypeRegisterField;
      return {
        ...state,
        data: {
          ...state.data,
          [form]: {
            ...state.data[form],
            [fieldName]:
              defaultValue || (state.data[form] && state.data[form][fieldName])
          }
        },
        validators: {
          ...state.validators,
          [form]: {
            ...state.validators[form],
            [fieldName]: validators || []
          }
        },
        errors: {
          ...state.errors,
          [form]: {
            ...state.errors[form],
            [fieldName]: []
          }
        }
      };
    }

    case FormActions.resetErrors: {
      const { form } = action.payload as ActionTypeResetErrors;

      const updatedState = { ...state };
      updatedState.errors[form] = {};
      return updatedState;
    }

    case FormActions.setFieldErrors: {
      const { formFieldsErrors } =
        action.payload as ActionTypeSetFormFieldsErrors;

      const updatedState = { ...state };
      updatedState.errors = { ...state.errors, ...formFieldsErrors };
      return updatedState;
    }

    default:
      return state;
  }
}
